import React from 'react';
import { FormattedMessage } from 'react-intl';

import CustomFontField from '../fields/CustomFont';
import FontVariantField from '../fields/FontVariant';
import TrackingField from '../fields/Tracking';

export const creditCard = [
    {
        name: 'card_name',
        type: 'text',
        label: <FormattedMessage defaultMessage="Name on card" description="Field label" />,
    },
    {
        name: 'card_number',
        type: 'text',
        label: <FormattedMessage defaultMessage="Card number" description="Field label" />,
    },
    {
        type: 'fields',
        isSection: true,
        fieldClassName: 'd-inline-block w-25 me-4',
        fields: [
            {
                name: 'expiration_date',
                type: 'text',
                label: (
                    <FormattedMessage defaultMessage="Expiration date" description="Field label" />
                ),
            },
            {
                name: 'cvv',
                type: 'text',
                label: <FormattedMessage defaultMessage="CVV" description="Field label" />,
            },
        ],
    },
];

export const contact = [
    {
        name: 'first_name',
        type: 'text',
        label: <FormattedMessage defaultMessage="First name" description="Field label" />,
    },
    {
        name: 'last_name',
        type: 'text',
        label: <FormattedMessage defaultMessage="Last name" description="Field label" />,
    },
    {
        name: 'email',
        type: 'email',
        label: <FormattedMessage defaultMessage="Email" description="Field label" />,
    },
    {
        name: 'phone',
        type: 'text',
        label: <FormattedMessage defaultMessage="Phone" description="Field label" />,
    },
];

export const billingContact = [
    {
        name: 'name',
        type: 'text',
        label: <FormattedMessage defaultMessage="Name" description="Field label" />,
    },
    {
        name: 'company_name',
        type: 'text',
        label: <FormattedMessage defaultMessage="Company name" description="Field label" />,
    },
    {
        name: 'address_1',
        type: 'text',
        label: <FormattedMessage defaultMessage="Address 1" description="Field label" />,
    },
    {
        name: 'address_2',
        type: 'text',
        label: <FormattedMessage defaultMessage="Address 2" description="Field label" />,
    },
    {
        name: 'country',
        type: 'select',
        label: <FormattedMessage defaultMessage="Country" description="Field label" />,
    },
    {
        name: 'city',
        type: 'text',
        label: <FormattedMessage defaultMessage="City" description="Field label" />,
    },
    {
        type: 'fields',
        isSection: true,
        fieldClassName: 'd-inline-block w-25 me-4 ',
        fields: [
            {
                name: 'province',
                type: 'text',
                label: <FormattedMessage defaultMessage="Province" description="Field label" />,
            },
            {
                name: 'postal_code',
                type: 'text',
                label: <FormattedMessage defaultMessage="Postal code" description="Field label" />,
            },
        ],
    },
];

export const organisation = [
    {
        name: 'name',
        type: 'text',
        label: <FormattedMessage defaultMessage="Name" description="Field label" />,
        required: true,
    },
];

export const organisationSettings = [
    {
        type: 'fields',
        label: <FormattedMessage defaultMessage="Tracking" description="Fields section label" />,
        isSection: true,
        fields: [
            {
                name: 'tracking',
                component: TrackingField,
            },
            {
                name: 'google_api_key',
                type: 'text',
                label: (
                    <FormattedMessage defaultMessage="Google API key" description="Field label" />
                ),
            },
        ],
    },
];

export const organisationBranding = [
    {
        type: 'fields',
        isSection: false,
        isList: true,
        name: 'branding',
        label: <FormattedMessage defaultMessage="Viewer style" description="Field label" />,
        fields: [
            {
                name: 'logo',
                type: 'image',
                label: <FormattedMessage defaultMessage="Logo" description="Field label" />,
            },
            {
                type: 'fields',
                name: 'colors',
                isSection: false,
                isList: false,
                // label: (
                //     <FormattedMessage defaultMessage="Color palette" description="Section label" />
                // ),
                fields: [
                    {
                        name: 'primary',
                        type: 'color',
                        label: (
                            <FormattedMessage
                                defaultMessage="Main Color"
                                description="Field label"
                            />
                        ),
                    },
                    {
                        name: 'secondary',
                        type: 'color',
                        label: (
                            <FormattedMessage
                                defaultMessage="Secondary color"
                                description="Field label"
                            />
                        ),
                    },
                ],
            },
            {
                type: 'fields',
                name: 'background',
                isSection: false,
                isList: false,
                label: <FormattedMessage defaultMessage="Background" description="Section label" />,
                fields: [
                    {
                        name: 'color',
                        type: 'color',
                        label: (
                            <FormattedMessage defaultMessage="Color" description="Field label" />
                        ),
                    },
                    {
                        name: 'image',
                        type: 'image',
                        label: (
                            <FormattedMessage defaultMessage="Image" description="Field label" />
                        ),
                    },
                ],
            },
            {
                type: 'fields',
                name: 'textStyles',
                isSection: false,
                isList: false,
                label: <FormattedMessage defaultMessage="Typography" description="Section label" />,
                fields: [
                    {
                        name: 'title',
                        type: 'field-with-form',
                        field: {
                            type: 'text-style',
                            className: 'p-0',
                        },
                        labelPath: 'fontFamily',
                        label: (
                            <FormattedMessage defaultMessage="Title" description="Field label" />
                        ),
                    },
                    {
                        name: 'media',
                        type: 'font',
                        label: (
                            <FormattedMessage
                                defaultMessage="Font file"
                                description="Field label"
                            />
                        ),
                    },
                ],
            },
        ],
    },
    {
        name: 'fonts',
        component: 'items',
        itemsField: {
            // type: 'field-with-form',
            component: CustomFontField,
            labelPath: 'name',
            fields: [
                {
                    name: 'name',
                    type: 'text',
                    label: (
                        <FormattedMessage
                            defaultMessage="Font family name"
                            description="Field label"
                        />
                    ),
                },
                {
                    name: 'media',
                    type: 'font',
                    label: (
                        <FormattedMessage defaultMessage="Font file" description="Field label" />
                    ),
                },
                {
                    name: 'variants',
                    type: 'items',
                    label: <FormattedMessage defaultMessage="Variants" description="Field label" />,
                    noItemLabel: (
                        <FormattedMessage
                            defaultMessage="No variant..."
                            description="No item label"
                        />
                    ),
                    addItemLabel: (
                        <FormattedMessage
                            defaultMessage="Add a variant"
                            description="Button label"
                        />
                    ),
                    itemsField: {
                        // isHorizontal: true,
                        component: FontVariantField,
                        fields: [
                            {
                                name: 'weight',
                                type: 'radios',
                                options: ['100', '200', '300', '400', '500', '600', '700', '900'],
                            },
                            {
                                name: 'style',
                                type: 'radios',
                                options: ['normal', 'italic', 'oblique'],
                                uncheckable: true,
                            },
                            {
                                name: 'media',
                                type: 'font',
                                label: (
                                    <FormattedMessage
                                        defaultMessage="Font file"
                                        description="Field label"
                                    />
                                ),
                            },
                        ],
                    },
                },
            ],
        },
        noItemLabel: <FormattedMessage defaultMessage="No fonts..." description="No item label" />,
        addItemLabel: <FormattedMessage defaultMessage="Add a font" description="Add item label" />,
        label: <FormattedMessage defaultMessage="Custom Fonts" description="Field label" />,
        withoutSort: true,
    },
];

export const teamMember = [
    {
        type: 'fields',
        isSection: false,
        isHorizontal: false,
        fields: [
            {
                name: 'email',
                type: 'email',
                label: <FormattedMessage defaultMessage="Email" description="Field label" />,
            },
            {
                name: 'role',
                type: 'select',
                label: <FormattedMessage defaultMessage="Role" description="Field label" />,
            },
        ],
    },
];

export const theme = [
    {
        name: 'title',
        type: 'text',
        label: <FormattedMessage defaultMessage="Theme Name" description="Field label" />,
        required: true,
    },
    {
        type: 'fields',
        isSection: true,
        isList: true,
        label: <FormattedMessage defaultMessage="Typography" description="Section label" />,
        fields: [
            {
                name: 'heading1',
                type: 'field-with-form',
                field: {
                    type: 'text-style',
                    className: 'p-0',
                    label: (
                        <FormattedMessage defaultMessage="Heading 1" description="Field label" />
                    ),
                },
                labelPath: 'fontFamily',
                label: <FormattedMessage defaultMessage="Heading 1" description="Field label" />,
            },
            {
                name: 'heading2',
                type: 'field-with-form',
                field: {
                    type: 'text-style',
                    className: 'p-0',
                    label: (
                        <FormattedMessage defaultMessage="Heading 2" description="Field label" />
                    ),
                },
                labelPath: 'fontFamily',
                label: <FormattedMessage defaultMessage="Heading 2" description="Field label" />,
            },
            {
                name: 'heading3',
                type: 'field-with-form',
                field: {
                    type: 'text-style',
                    className: 'p-0',
                    label: (
                        <FormattedMessage defaultMessage="Heading 3" description="Field label" />
                    ),
                },
                labelPath: 'fontFamily',
                label: <FormattedMessage defaultMessage="Heading 3" description="Field label" />,
            },
            {
                name: 'button',
                type: 'field-with-form',
                field: {
                    type: 'text-style',
                    className: 'p-0',
                    label: <FormattedMessage defaultMessage="Button" description="Field label" />,
                },
                labelPath: 'fontFamily',
                label: <FormattedMessage defaultMessage="Button" description="Field label" />,
            },
            {
                name: 'text',
                type: 'field-with-form',
                field: {
                    type: 'text-style',
                    className: 'p-0',
                    label: <FormattedMessage defaultMessage="Text" description="Field label" />,
                },
                labelPath: 'fontFamily',
                label: <FormattedMessage defaultMessage="Text" description="Field label" />,
            },
        ],
    },
    {
        type: 'fields',
        isSection: true,
        isList: true,
        label: <FormattedMessage defaultMessage="Color palette" description="Section label" />,
        fields: [
            {
                name: 'colorsPrimary',
                type: 'color',
                label: <FormattedMessage defaultMessage="Main Color" description="Field label" />,
            },
            {
                name: 'colorsSecondary',
                type: 'color',
                label: (
                    <FormattedMessage defaultMessage="Secondary color" description="Field label" />
                ),
            },
        ],
    },
    {
        type: 'fields',
        isSection: true,
        isList: true,
        label: <FormattedMessage defaultMessage="Background" description="Section label" />,
        fields: [
            {
                name: 'backgroundColor',
                type: 'color',
                label: <FormattedMessage defaultMessage="Color" description="Field label" />,
            },
            {
                name: 'backgroundImage',
                type: 'image',
                label: <FormattedMessage defaultMessage="Image" description="Field label" />,
            },
        ],
    },
    {
        type: 'fields',
        isSection: true,
        isList: true,
        label: <FormattedMessage defaultMessage="Call to action" description="Section label" />,
        fields: [
            {
                name: 'ctaText',
                type: 'field-with-form',
                field: {
                    type: 'text-style',
                    className: 'p-0',
                    label: (
                        <FormattedMessage
                            defaultMessage="Call to action"
                            description="Section label"
                        />
                    ),
                },
                labelPath: 'fontFamily',
                label: <FormattedMessage defaultMessage="Text" description="Field label" />,
            },
            {
                name: 'ctaButton',
                type: 'field-with-form',
                field: {
                    type: 'box-style',
                    className: 'p-0',
                    label: (
                        <FormattedMessage
                            defaultMessage="Call to action"
                            description="Section label"
                        />
                    ),
                },
                label: <FormattedMessage defaultMessage="Button" description="Field label" />,
            },
        ],
    },
    {
        type: 'fields',
        isSection: true,
        isList: true,
        label: <FormattedMessage defaultMessage="Badge" description="Section label" />,
        fields: [
            {
                name: 'badgeText',
                type: 'field-with-form',
                field: {
                    type: 'text-style',
                    className: 'p-0',
                    label: <FormattedMessage defaultMessage="Badge" description="Section label" />,
                },
                labelPath: 'fontFamily',
                label: <FormattedMessage defaultMessage="Text" description="Field label" />,
            },
            {
                name: 'badgeButton',
                type: 'field-with-form',
                field: {
                    type: 'box-style',
                    className: 'p-0',
                    label: <FormattedMessage defaultMessage="Badge" description="Section label" />,
                },
                label: <FormattedMessage defaultMessage="Button" description="Field label" />,
            },
        ],
    },
];
